window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderAutoplay = e.dataset.autoplay,
      loopSelector = e.dataset.sliderLoop,
      loopInit = false,
      autoPlayValue = false,
      autoPlayTime = parseInt(e.dataset.autoplayTime);

    if (sliderAutoplay == "true") {
      autoPlayValue = {
        delay: autoPlayTime,
      };
    }

    if (loopSelector == "true") {
      loopInit = true;
    }

    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      mobileShow = parseInt(e.dataset.showMobile);
      if (typeof e.dataset.showTablet !== "undefined") {
        tabletShow = e.dataset.showTablet;
      } else {
        tabletShow = extraLargeDesktopShow;
      }
    } else {
      sliderContainer = false;
    }

     // Pagination configuration
    let paginationType = e.dataset.paginationType || 'bullets';
    let showPagination = e.dataset.showPagination === 'true';
    let paginationConfig = {};
    if (showPagination) {
        if (paginationType === 'progress-bar') {
          paginationConfig = {
            el: e.querySelector(".swiper-pagination"),
            type: "progressbar",
          };
        } else {
          let paginationTypeValue = paginationType === 'counter' ? 'fraction' : 'bullets';
          paginationConfig = {
            el: e.querySelector(".swiper-pagination"),
            clickable: true,
            type: paginationTypeValue,
          };
        }
      } else {
        paginationConfig = false;
      }

    var featuredCollection = new Swiper(sliderContainer, {
      loop: true,
      slidesPerView: mobileShow,
      spaceBetween: 20,
      autoplay: autoPlayValue,
      pagination: paginationConfig,
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });    

    if (!sliderContainer == false && sliderAutoplay == "true") {
      sliderContainer.addEventListener("mouseenter", (e) => {
        featuredCollection.autoplay.stop();
      });
      sliderContainer.addEventListener("mouseleave", (e) => {
        featuredCollection.autoplay.start();
      });
    }
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections(),
    headerMainMenu = new theme.Sections();

  sections.register("announcement-bar", theme.announcement);
  sections.register("header", theme.headerSection);
  headerSearchModule.register("header", theme.headerSearch);
  headerStickyModule.register("header", theme.headerSticky);
  headerMainMenu.register("header", theme.headerMainMenuModule);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("accordion", theme.accordion);
  sections.register("blog", theme.blog);
  sections.register("lookbook", theme.lookbookSlider);
  sections.register("timeline", theme.timelineSlider);
});

var productCountdown = class extends HTMLElement {
  constructor() {
        super();       
    }
    connectedCallback() {
       this.invertory_el = document.body.querySelector('.variant-inventory-text');
       if(this.invertory_el){
        setInterval(() => {
            this._msToTime();
          }, 1000);
       }
    }
  _msToTime = function() {
            var invertory_el = this.invertory_el;
            var invertory_text = invertory_el.innerHTML;
            
            // var custom_shipping_text =  $('body').find('.custom-shipping-text').html();
            var order_time = '';
            var order_el = this;
            var boise_holidays_flag = false;
            

            // if(custom_shipping_text.length) {
            //   invertory_text = custom_shipping_text;
            // }
           
            
            if(invertory_text.indexOf('Boise') + 1) {
              order_time = '6pm';
                boise_holidays_flag = true;
            } else if (invertory_text.indexOf('Chicago') + 1) {
              order_time = '3:00pm';
            }else if (invertory_text.indexOf('Augusta') + 1) {
              order_time = '2:00pm';
            } else if (invertory_text.indexOf('NC') + 1) {
              order_time = '1:30pm';
            } else {
              order_time = '6pm';
            }

            var cutoff_time = Date.today().at(order_time);
            var current_time = moment.tz("America/New_York").format('LTS'); // time zona New York 
                      
          
            var current_time_with_day = moment.tz("America/New_York").format('LLLL');
            var current_time_with_day_datajs = Date.parse(current_time_with_day); // convert time to date.js
            var compare = Date.compare(current_time_with_day_datajs, cutoff_time);  

              if(compare == 1){
                current_time = Date.parse("11:59:59 PM"); // convert time to date.js
              }else{
                current_time = Date.parse(current_time); // convert time to date.js
              }
            
           
            var hourDiff = cutoff_time - current_time; //in ms
            var seconds = parseInt((hourDiff / 1000) % 60),
                minutes = parseInt((hourDiff / (1000 * 60)) % 60),
                hours = parseInt((hourDiff / (1000 * 60 * 60)) % 24);           
			
            
            
           
            if( Date.today().is().saturday() || Date.today().is().sunday() || ( Date.today().is().friday()  && hourDiff <= 0) ) {
              var next_monday = Date.parse("next monday").toString("ddd MMM d");

              if(boise_holidays_flag) {
                var holidays = this.getAttribute("boise_holidays_day"); 
              } else {
                var holidays = this.getAttribute("holidays"); 
              }

              var flag_holiday = true;
              if(holidays == null || holidays == '') {
                flag_holiday = false;
              }

              if(flag_holiday) {
                holidays = holidays.split(','); 

                var day_today = Date.today().next().monday();
              				
                for(var i = 0; i < holidays.length; i++) {               
                  if(Date.compare(day_today, Date.parse(holidays[i])) == 0) {
                    day_today = day_today.add(1).day();                       
                  } 
                }

                var next_working_day = day_today.toString("ddd MMM d");
                order_el.innerHTML = 'Order now to ship ' +  next_working_day;
              } else {
                order_el.innerHTML = 'Order now to ship ' +  next_monday;
              }


              
            }else {

              if(boise_holidays_flag) {
                 var holidays = this.getAttribute("boise_holidays_day"); 
              } else {
                var holidays = this.getAttribute("holidays"); 
              }

                var flag_holiday = true;
                if(holidays == null || holidays == '') {
                  flag_holiday = false;
                }
               
                if(flag_holiday) {
                  holidays = holidays.split(','); 

                  var day_today = Date.today();
                  var next_day = Date.today().add(1).day(); 						
                  
                  var working_day = true;
                  
                  for(var i = 0; i < holidays.length; i++) {               
				
                    if(Date.compare(day_today, Date.parse(holidays[i])) == 0) {
                      working_day = false;
                      day_today = day_today.add(1).day();                       
                      if(day_today.is().saturday() || day_today.is().sunday() || Date.today().is().sunday()) { 
                        var next_monday = Date.parse("next monday").toString("ddd MMM d");
                        order_el.innerHTML ='Order now to ship ' + next_monday;
                      }  else {
                          order_el.innerHTML = 'Order now to ship tomorrow';
                      }      
                      
                      
                     } else if(Date.compare(next_day, Date.parse(holidays[i])) == 0) {
                      working_day = false;
                      next_day = next_day.add(1).day(); 
                      if(next_day.is().saturday() || next_day.is().sunday()) { 
                        if(!day_today.is().saturday() && !day_today.is().sunday()  && hourDiff > 0 )  {
                          order_el.innerHTML = 'Order in the next <b>' +  hours + ' hours ' + minutes + ' mins ' + seconds + ' seconds </b>  to ship today';		                        
                        } else {
                          var next_monday = Date.parse("next monday").toString("ddd MMM d");
                          var next_monday_date =  Date.parse("next monday");
                          if(typeof holidays[i+1] != "undefined"){
                          if(Date.compare(next_monday_date, Date.parse(holidays[i+1])) == 0){
                            //console.log("111");
                            next_monday_date = next_monday_date.add(1).day(); 
                            var next_monday_str = next_monday_date.toString("ddd MMM d")
                            order_el.innerHTML = 'Order now to ship ' + next_monday_str;
                          }else{
                            //console.log("222");
                          order_el.innerHTML = 'Order now to ship ' + next_monday;
                          }
                          }else{
                             order_el.innerHTML = 'Order now to ship ' + next_monday;
                          }
                        }
                      }  else {
                        if(hourDiff > 0) {               
                          order_el.innerHTML = 'Order in the next <b>' +  hours + ' hours ' + minutes + ' mins ' + seconds + ' seconds </b>  to ship today';
                        } else  { 
                          order_el.innerHTML = 'Order now to ship ' + Date.parse(next_day).toString("ddd MMM d");  
                        }
                      }                      
                    }
                  }

                  if(working_day) {

                    if(hourDiff > 0) {               
                      order_el.innerHTML = 'Order in the next <b>' +  hours + ' hours ' + minutes + ' mins ' + seconds + ' seconds </b>  to ship today';
                    } else  { 
                      order_el.innerHTML = 'Order now to ship tomorrow';
                    }
                  }

                } else {
                  if(hourDiff > 0) {               
                    order_el.innerHTML = 'Order in the next <b>' +  hours + ' hours ' + minutes + ' mins ' + seconds + ' seconds </b>  to ship today';
                  } else  { 
                    order_el.innerHTML = 'Order now to ship tomorrow';
                  }
                }            
            }
  }
};
window.customElements.get("product-countdown") || window.customElements.define("product-countdown", productCountdown);

class ProductAppSwatches extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var swatches = this.querySelectorAll('.swatch-element');
    var productMainAllImages = this.closest('.product').querySelectorAll('.product__media-item .product__media img');
    var productInventoryMessage = this.closest('.product').querySelector('.product__inventory > span');
    var productInventoryProgressbar = this.closest('.product').querySelector('.stock_progress_bar');

    if (productMainAllImages.length) {
      productMainAllImages.forEach(function(item) {
        item.setAttribute('data-src', item.getAttribute('src'));
        item.setAttribute('data-srcset', item.getAttribute('srcset'));
      });
    }

    if (swatches.length) {
      swatches.forEach(function(item) {
        item.addEventListener("mouseenter", function() {
          var itemImg = this.querySelector('.swatch-image-block img');
          var productMainImage = this.closest('.product').querySelector('.product__media-item.is-active .product__media img');
          if (itemImg && productMainImage) {
            productMainImage.setAttribute('src', itemImg.getAttribute('src'));
            productMainImage.removeAttribute('srcset');
          }

          if (!this.classList.contains('current')) {
            if (productInventoryMessage) {
              productInventoryMessage.innerHTML = this.getAttribute('data-progress-message');
              productInventoryMessage.style.color = this.getAttribute('data-inventory-color');
            }

            if (productInventoryProgressbar) {
              productInventoryProgressbar.style.background = this.getAttribute('data-progress-foregraund');
              productInventoryProgressbar.style.width = this.getAttribute('data-progress-width');
            }
          }
        });

        item.addEventListener("mouseleave", function() {
          var productMainImage = this.closest('.product').querySelector('.product__media-item.is-active .product__media img');
          if (productMainImage) {
            productMainImage.setAttribute('src', productMainImage.getAttribute('data-src'));
            productMainImage.setAttribute('srcset', productMainImage.getAttribute('data-srcset'));
          }

          if (productInventoryMessage) {
            productInventoryMessage.innerHTML = productInventoryMessage.getAttribute('data-message');
            productInventoryMessage.style.color = null;
          }

          if (productInventoryProgressbar) {
            productInventoryProgressbar.style.background = null;
            productInventoryProgressbar.style.width = productInventoryProgressbar.getAttribute('data-width');
          }
        });
      });
    }
  }
}

customElements.define("product-app-swatches", ProductAppSwatches);